/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

var getJSON = {
    "arab": {
        "_digits": "٠١٢٣٤٥٦٧٨٩"
    }
};

/**
 * Intesa loan calculator
 *
 */
Intesa.InputToArab = function() {
    var inputarab = this;

    this.init = function() {
        console.log('Component -> InputToArab');

        $('strong.pop1__value__strong.translate_arab').text(function(i, v) {
            return inputarab.changeToArab(v);
        });

        //number of phone
        var idField_arabPhoneNumber = '#idField-arab-phoneNumber';
        var idField_phoneNumber = '#idField-phoneNumber';

        var arrayOfIds = $.map($('[id^="idField-phoneNumber"]'), function(n, i) {
            return n.id.replace("idField-phoneNumber", "");
        });

        for (var i = 0; i < arrayOfIds.length; i++) {
            inputarab.setNumSystemArab($(idField_arabPhoneNumber + arrayOfIds[i]), $(idField_phoneNumber + arrayOfIds[i]));

            inputarab.setNumSystem($(idField_phoneNumber + arrayOfIds[i]));

            $(idField_phoneNumber + arrayOfIds[i] + '.arab_phone_language').on('input', function(e) {
                $(this).val();
            });
        }
        //end number of phone

        //prefix of phone
        var idField_cityPrefix = '#idField-cityPrefix';
        var idField_arabCityPrefix = '#idField-arab-cityPrefix';
        var contentInputPhonePrefix = '#contentInputPhonePrefix';
        var prefixList = '#prefixList';
        var prefixListWrapper = '#prefixListWrapper';

        var arrayOfIdsPrefix = $.map($('[id^="idField-cityPrefix"]'), function(n, i) {
            return n.id.replace("idField-cityPrefix", "");
        });

        for (var i = 0; i < arrayOfIdsPrefix.length; i++) {
            inputarab.setNumSystemArab($(idField_arabCityPrefix + arrayOfIdsPrefix[i]), $(idField_cityPrefix + arrayOfIdsPrefix[i]));

            inputarab.setNumSystem($(idField_cityPrefix + arrayOfIdsPrefix[i]));

            if ($(idField_arabCityPrefix + arrayOfIdsPrefix[i] + '.arab_phone_language').length > 0) {
                $(idField_arabCityPrefix + arrayOfIdsPrefix[i]).val(inputarab.changeToArab($(idField_cityPrefix + arrayOfIdsPrefix[i]).val()));
            }

            $(idField_cityPrefix + arrayOfIdsPrefix[i]).on('input', function(e) {
                $(this).val();
            });

            this.contentInputPhonePrefix(
                idField_cityPrefix + arrayOfIdsPrefix[i],
                idField_arabCityPrefix + arrayOfIdsPrefix[i],
                contentInputPhonePrefix + arrayOfIdsPrefix[i],
                prefixList + arrayOfIdsPrefix[i],
                prefixListWrapper + arrayOfIdsPrefix[i]);

            this.urlPrefix(
                idField_cityPrefix + arrayOfIdsPrefix[i],
                idField_arabCityPrefix + arrayOfIdsPrefix[i],
                contentInputPhonePrefix + arrayOfIdsPrefix[i],
                prefixList + arrayOfIdsPrefix[i],
                prefixListWrapper + arrayOfIdsPrefix[i]);
        }

    }

    this.urlPrefix = function(cityPrefix, arabCityPrefix, contentInputPhonePrefix, prefixList, prefixListWrapper) {
        var url = $(cityPrefix).data('country-codes');
        var prefixList = $(prefixList)
        prefixList.empty();

        $.getJSON(url, function(data) {
            this.dataPrefix = data
            $.each(data, function(key, entry) {

                prefixList.append($('<li><a href="javascript:;" data-prefix="' + entry.dial_code + '"><span>' + entry.dial_code + '</span> (' + entry.name + ') </a> </li>'));

            });

            $(contentInputPhonePrefix).find('.for__leaveMessage__internationalPrefix__listWrapper').on('click', 'li', function(e) {
                var lengthValidationCountry = $(cityPrefix).data('maxlength-country');
                var parserLenghtValidationCountry = $(cityPrefix).data('parserlenght-country');
                var parserLenghtValidationOthersCountries = $(cityPrefix).data('parserlenght-others-countries');
                var lengthValidationOthersCountries = $(cityPrefix).data('maxlength-others-countries');

                var textValue = $(e.currentTarget).find('a').data('prefix').replace('+', '');
                if ($(e.currentTarget).find('a').data('prefix') === '+2') {
                    $(contentInputPhonePrefix).next().find('input').attr('maxlength', lengthValidationCountry).attr('data-parsley-pattern', parserLenghtValidationCountry)
                } else {
                    $(contentInputPhonePrefix).next().find('input').attr('data-parsley-pattern', parserLenghtValidationOthersCountries).attr('maxlength', lengthValidationOthersCountries)
                }

                setTimeout(function() {
                    $(cityPrefix).val(inputarab.returnToNumeric(textValue)).addClass('fc-edited').trigger("input");

                    $(cityPrefix).removeClass('parsley-error');

                    $('.for__phoneNumber__boxErrors').css({ "display": "none" });

                    if (!inputarab.isNumber(textValue)) {
                        $(arabCityPrefix).val(textValue);
                    } else {
                        $(cityPrefix).val(textValue);
                    }

                    $(contentInputPhonePrefix).find(prefixListWrapper)[0].style.display = "none";
                }, 2);

            });
        });
    }

    this.contentInputPhonePrefix = function(cityPrefix, arabCityPrefix, contentInputPhonePrefix, prefixList, prefixListWrapper) {
        $(arabCityPrefix).on('keyup', function() {
            $(contentInputPhonePrefix).find(prefixListWrapper)[0].style.display = "block";

            ul = $(contentInputPhonePrefix).find(prefixList);

            li = ul.find('li');

            input = $(arabCityPrefix);

            count = 0;

            filter = input.val().toLowerCase();

            for (i = 0; i < li.length; i++) {

                a = li[i].getElementsByTagName("a")[0];

                txtValue = a.textContent || a.innerText;

                if (txtValue.toLowerCase().indexOf(filter) > -1) {

                    li[i].style.display = "block";

                } else {

                    li[i].style.display = "none";

                    count++;

                }

            }
        });
        $(cityPrefix).on('keyup', function() {
            $(contentInputPhonePrefix).find(prefixListWrapper)[0].style.display = "block";

            ul = $(contentInputPhonePrefix).find(prefixList);

            li = ul.find('li');

            input = $(cityPrefix);

            count = 0;

            filter = input.val().toLowerCase();

            for (i = 0; i < li.length; i++) {

                a = li[i].getElementsByTagName("a")[0];

                txtValue = a.textContent || a.innerText;

                if (txtValue.toLowerCase().indexOf(filter) > -1) {

                    li[i].style.display = "block";

                } else {

                    li[i].style.display = "none";

                    count++;

                }

            }
        });
    }

    this.setNumSystemArab = function(inputArabControl, inputNumberControl) {
        if (inputArabControl && inputNumberControl) {
            inputArabControl.keydown(function(event) {

                if (event.key === "Backspace" || event.key === "Delete") {
                    setTimeout(function() {
                        var newVal = $(inputArabControl).val();
                        newVal = inputarab.returnToNumeric(newVal);
                        inputNumberControl.val(newVal).trigger('input');
                    }, 2);
                } else if (inputarab.isArab(event.key) || inputarab.isNumber(event.key)) {
                    event.preventDefault();
                    if (inputNumberControl.attr('data-max-length') && inputNumberControl.val().length >= inputNumberControl.attr('data-max-length')) {
                        return;
                    }

                    var s = inputArabControl.val();
                    var i = inputArabControl.prop('selectionStart');
                    s = s.substr(0, i) + inputarab.changeToArab(event.key) + s.substr(inputArabControl.selectionEnd);
                    inputArabControl.val(s);
                    inputArabControl.prop('selectionStart', inputArabControl.selectionEnd = i + 1);
                    var newVal = inputArabControl.val();
                    var newValInt = inputarab.returnToNumeric(newVal);
                    inputNumberControl.val(newValInt).trigger('input');
                }
            });

            inputArabControl.bind("paste change", function(event) {
                var clipboardData, pastedData;
                var result = '';
                // Stop data actually being pasted into div
                event.stopPropagation();
                event.preventDefault();

                clipboardData = event.clipboardData || window.clipboardData || event.originalEvent.clipboardData;
                if (clipboardData) {
                    pastedData = clipboardData.getData('text');
                } else {
                    pastedData = event && event.currentTarget ? event.currentTarget.value : '';
                }

                if (pastedData && pastedData.length > 0) {
                    if (inputarab.isArab(pastedData)) {
                        inputArabControl.val(pastedData);
                        result = inputarab.returnToNumeric(pastedData);
                    } else if (inputarab.isNumber(pastedData)) {
                        result = pastedData;
                        inputArabControl.val(inputarab.changeToArab(pastedData))
                    }
                }

                inputNumberControl.val(result).trigger("input");
            });
        }
    }

    this.setNumSystem = function(inputNumberControl) {
        inputNumberControl.keydown(function(event) {
            if (inputNumberControl.val().length >= inputNumberControl.attr('data-max-length')) {
                inputNumberControl.val(inputNumberControl.val().substring(0, inputNumberControl.attr('data-max-length') - 1));
                return;
            }
        });
    }

    this.returnToNumeric = function(arabic_number) {
        var array_arab = arabic_number.split("");
        var result = "";
        for (var i = 0; i < array_arab.length; i++) {
            switch (array_arab[i]) {
                case "٠":
                    result += "0";
                    break;
                case "١":
                    result += "1";
                    break;
                case "٢":
                    result += "2";
                    break;
                case "٣":
                    result += "3";
                    break;
                case "٤":
                    result += "4";
                    break;
                case "٥":
                    result += "5";
                    break;
                case "٦":
                    result += "6";
                    break;
                case "٧":
                    result += "7";
                    break;
                case "٨":
                    result += "8";
                    break;
                case "٩":
                    result += "9";
                    break;
                default:
                    result += array_arab[i];
            }
        }
        return result;
    };

    this.changeToArab = function(chars_elem) {
        var chars = chars_elem.split("");
        for (var i = 0; i < chars.length; i++) {
            if (parseFloat(chars[i]) > -1) {
                chars[i] = getJSON.arab._digits[chars[i]];
            }
        }
        return chars.join('');
    }

    this.isArab = function(preword) {
        var word = ("" + preword).split("")
        var regex = new RegExp("[*٠١٢٣٤٥٦٧٨٩]");
        for (var i = 0; i < word.length; i++) {
            if (regex.test(word[i])) {
                return true;
            }
        }
        return false;
    }

    this.isNumber = function(preword) {
        var word = ("" + preword).split("");
        var regex = new RegExp(/\d/);
        for (var i = 0; i < word.length; i++) {
            if (regex.test(word[i])) {
                return true;
            }
        }
        return false;
    }
};

/**
 * Get class instance
 *
 */
Intesa.InputToArab.getInstance = function() {

    if (!window.intesa) {

        window.intesa = new Object();

    }

    if (!window.intesa.input_to_arab) {

        window.intesa.input_to_arab = new Intesa.InputToArab();

    }

    return window.intesa.input_to_arab;

};